import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import {
  normalizeDashboardLayout,
  readStoredLayout,
  migrateLegacyPreferences,
} from "../utils/dashboardPreferences";

const API_URL = process.env.REACT_APP_API_URL;

const readUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user")) || {};
  } catch {
    return {};
  }
};

export function useDashboardLayout() {
  const [raw, setRaw] = useState(() => readStoredLayout());
  const migratedRef = useRef(false);

  const saveLayout = useCallback(async (partial) => {
    const token = localStorage.getItem("token");
    const res = await axios.patch(
      `${API_URL}/users/me/dashboard-layout`,
      partial,
      { headers: { Authorization: `Bearer ${token}` } },
    );

    setRaw(res.data);

    const user = readUser();
    user.dashboardLayout = res.data;
    localStorage.setItem("user", JSON.stringify(user));

    return res.data;
  }, []);

  useEffect(() => {
    if (migratedRef.current) return;
    migratedRef.current = true;

    const user = readUser();
    const hasServerLayout =
      user.dashboardLayout &&
      Array.isArray(user.dashboardLayout.blocks) &&
      user.dashboardLayout.blocks.length > 0;
    if (hasServerLayout) return;

    const migrated = migrateLegacyPreferences(user.id);
    if (migrated) {
      saveLayout(migrated).catch((err) =>
        console.error(
          "No se pudo migrar la personalización del dashboard:",
          err,
        ),
      );
    }
  }, [saveLayout]);

  const layout = useMemo(() => normalizeDashboardLayout(raw), [raw]);

  return { layout, saveLayout };
}
